import { API_BASE } from '../config/api';

export const mediaUrl = (url) => (!url ? null : /^(https?:|data:|blob:)/.test(url) ? url : `${API_BASE}${url.startsWith('/') ? '' : '/'}${url}`);
